exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-2001a8e8]{text-align:center;margin:30px 0 20px}\n", ""]);

// exports
